import { EmrID } from "../../Types/Common/src/ids";
import { PatientDemographics } from "../../Types/Common/src/demographics";
import { OrganizationConsent } from "../../Types/Common/src/organization-consent";
import { Patient } from "../../Types/Common/src/patient";
import { PatientNameType } from "./patientReducer";
import { SET_PATIENT, CLEAR_PATIENT, SET_PATIENT_GRAPH, SET_PATIENT_DEMOGRAPHICS, SET_ORGANIZATION_CONSENT, SET_PATIENT_NAME, SET_CFF_ID, SET_SPIROMETER_ID, SET_EMR_ID } from "./actionTypes";

export const setPatient = (payload: Patient) => ({ type: SET_PATIENT, payload });

export const setPatientGraph = (payload: any) => ({ type: SET_PATIENT_GRAPH, payload });

export const setPatientDemographics = (payload: PatientDemographics) => ({ type: SET_PATIENT_DEMOGRAPHICS, payload });

export const setOrganizationConsent = (payload: OrganizationConsent) => ({ type: SET_ORGANIZATION_CONSENT, payload });

export const setPatientName = (payload: PatientNameType) => ({ type: SET_PATIENT_NAME, payload });

export const setEmrID = (payload: EmrID) => ({ type: SET_EMR_ID, payload });

export const setCffID = (payload: string) => ({ type: SET_CFF_ID, payload });

export const setSpirometerID = (payload: string) => ({ type: SET_SPIROMETER_ID, payload });

export const clearPatient = () => ({ type: CLEAR_PATIENT });